<template>
<v-container>
  <h3>Bank Collateral Details</h3>
  <v-container>
  <v-row>
      <!-- <v-col col="3">
        <ClarionDateControl
        :isIsoDate="true"
        label="As Of"
        v-model="collateralInfo.asOfDate"
        />
      </v-col> -->
    <v-col cols="3">
      <v-text-field
        label="Bank Initials"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="collateralInfo.bankIntials"
        :readonly="isReadOnly"
      ></v-text-field>
    </v-col>
    <v-col cols="3">
      <v-text-field
        label="Bank Name"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="collateralInfo.bankName"
        :readonly="isReadOnly"
      ></v-text-field>
    </v-col>
    <!-- <v-col cols="3">
      <v-text-field
        label="Cash Balance"
        v-model="collateralInfo.cashBalance"
        @blur="formatAmountFields"
      ></v-text-field>
    </v-col> -->
  </v-row>
  </v-container>
   <v-data-table
    dense
    fixed-header
    :headers="headers"
    :items-per-page="-1"
    hide-default-footer
    :items="collateralInfo.details || []"
    class="elevation-1 glBankCollateralDetails collateral-compact-table"
  >
    <template  v-slot:[`item.asOfDate`]="{ item }">
        <ClarionDateControl
          :isIsoDate="true"
          v-model="item.asOfDate"
          dense
          single-line
          hide-details="auto"
          :isReadOnly="isReadOnly"
        />
    </template>
     <!-- <template v-slot:[`item.description`]="{ item }">
      <v-text-field
        dense
        single-line
        label="Description"
        v-model="item.description"
      ></v-text-field>
     </template>
     <template v-slot:[`item.amount`]="{ item }">
      <v-text-field
        dense
        single-line
        label="Amount"
        v-model="item.amount"
      ></v-text-field>
     </template> -->

     <template v-slot:[`item.loc`]="{ item }">
      <v-text-field
        v-model="item.loc"
        label="LOC/Collateral"
        dense
        single-line
        hide-details
        :readonly="isReadOnly"
      ></v-text-field>
    </template>

    <template v-slot:[`item.pledges`]="{ item }">
      <v-text-field
        v-model="item.pledges"
        dense
        single-line
        hide-details
        label="Pledges"
        :readonly="isReadOnly"
      ></v-text-field>
    </template>

    <template v-slot:[`item.sweep`]="{ item }">
      <v-text-field
        v-model="item.sweep"
        dense
        single-line
        hide-details
        label="Sweep"
        :readonly="isReadOnly"
      ></v-text-field>
    </template>
     <template v-slot:[`item.fdic`]="{ item }">
      <v-text-field
        dense
        single-line
        hide-details
        label="FDIC"
        v-model="item.fdic"
        :readonly="isReadOnly"
      ></v-text-field>
    </template>

  </v-data-table>
  </v-container>
</template>

<script>
import {
  mapState,
} from 'vuex';
import {
  mdiPlus,
  mdiDelete,
} from '@mdi/js';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'glBankCollateralDetails',
  mixins: [GlobalToCaps],
  created() {
  },
  components: {
    ClarionDateControl,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'glBankCollateralDetails-dialog',
    },
    value: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    icons: {
      mdiPlus,
      mdiDelete,
    },
    defaultHeaders: [
      { text: 'As Of', value: 'asOfDate' },
      // { text: 'Description', value: 'description' },
      // { text: 'Amount', value: 'amount' },
      { text: 'LOC/Collateral', value: 'loc' },
      { text: 'Pledges', value: 'pledges' },
      { text: 'Sweep/ICS', value: 'sweep' },
      { text: 'FDIC', value: 'fdic' },
    ],
  }),
  computed: {
    headers() {
      return this.defaultHeaders;
    },
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    collateralInfo: {
      get() {
        if (this.value && Object.keys(this.value).length > 0) {
          return (this.value);
        }
        return {
          details: [],
        };
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
  },
};
</script>

<style scoped>
::v-deep .v-input.v-text-field {
  padding-top: 0px;
}
</style>

<style scoped src="../../../assets/collateral-compact-table.css"></style>
